export const getGenderDisplay = (genderCode: string): string => {
    switch (genderCode) {
        case 'M':
            return 'Vrouw';
        case 'H':
            return 'Man';
        default:
            return genderCode;
    }
};